// AUTO-GENERATED by scripts/fetch-cms-content.mjs (DIT-264 / CMS feature flags).
// Gitignored — do NOT edit or commit. Empty `{}` means "nothing killed".
/* eslint-disable */
export const CMS_FLAGS: Record<string, Record<string, boolean>> = {
  "int": {},
  "be": {
    "check_in_at_work": true,
    "law_2027": true
  },
  "lt": {}
};
